import ReactDOM from 'react-dom'
import App from "./App.tsx";
import { DataPageProvider } from './Context/DataPageContext.tsx'; // Import the DataPageProvider


((Drupal, drupalSettings) => {
  Drupal.behaviors.catalogBehavior = {
    attach: function(context: { querySelector: (arg0: string) => any; }) {
      const el = context.querySelector('#catalog-root');
      if (el) {
        const dataPage: string = drupalSettings.ifapme_catalog.dataPage;
        const link: string = drupalSettings.ifapme_catalog.link;
        const linkLabel: string = drupalSettings.ifapme_catalog.linkLabel;
        ReactDOM.render(
          <DataPageProvider>
            <App dataPage={dataPage} link={link} linkLabel={linkLabel}/>
          </DataPageProvider>, el
        );
      } else {
        console.error("Element not found");
      }
    },
  }
})(Drupal, drupalSettings);
